import React from 'react';
import {useTranslation} from 'react-i18next';
import EditorLayout from '../../../../components/Layouts/EditorLayout';
import {PortalSettingsGetSchema} from '../../../../api/DBSchema/PortalSettings';
import RowLayout from '../../../../components/Layouts/RowLayout';
import SMCButton from '../../../../components/Simple/SMCButton';
import SMCTable from '../../../../components/core/SMCTable/SMCTable';
import {dateToString} from '../../../../utils/utils';
import AddFirmwareToPortalModal from '../../../PopupPages/AddFirmwareToPortalModal';
import {useBoolean, useSort} from '../../../../utils/hooks';
import {SortDirections} from "../../../../api/consts";
import {buildWeighedSort, buildNumberSort, buildStringSortCaseInsensitive} from "../../../../utils/sortUtils";
import {FirmwareGetListSchema} from "../../../../api/DBSchema/Firmware";

const pageSchema = PortalSettingsGetSchema.pages.firmware;
const pageId = pageSchema.pageId;

const applianceWeights = {
    [FirmwareGetListSchema.applianceValues.type600]:  0,
    [FirmwareGetListSchema.applianceValues.type1200]: 1,
    [FirmwareGetListSchema.applianceValues.typeS1S2]: 2,
    [FirmwareGetListSchema.applianceValues.typeV0V1]: 3,
    [FirmwareGetListSchema.applianceValues.typeV2V3]: 4,
}

function ReleaseDateCell({value}) {
    return value ? dateToString(value) : null;
}

function PortalSettingsFirmware({
    portalSettingsObject,
    reloadSettingsFirmware,
    editorWidth,
    editorHeight
}) {
    const { t } = useTranslation();

    const pageData = portalSettingsObject[pageId];

    const availableFirmwares       = pageData[pageSchema.availableFirmwares];
    const availableFirmwaresSchema = pageSchema.availableFirmwaresSchema;

    const [isAddFirmwareModalOpen, openAddFirmwareModal, closeAddFirmwareModal] = useBoolean(false);
    const { sortBasis, sortDirection, setSort } = useSort('releaseDate', SortDirections.DESCENDING);

    return (
        <EditorLayout>
            <RowLayout>
                <SMCButton icon="new" variant="ghost" onClick={openAddFirmwareModal}>{t('SMC_GEN_NEW')}</SMCButton>
            </RowLayout>
            <SMCTable
                height={editorHeight < 200 ? 100 : editorHeight-100} // 100px smaller then editor height, with minimum height of 100px
                width={editorWidth-300}
                columns={[
                    { id: 'name',        header: t('SMP.NAME'),                           accessor: availableFirmwaresSchema.name,                width: 300,  sort: buildStringSortCaseInsensitive(availableFirmwaresSchema.name)                                 },
                    { id: 'releaseDate', header: t('SMP.SETTINGS.FIRMWARE.RELEASE_DATE'), accessor: availableFirmwaresSchema.releaseDate,         width: 130,  sort: buildNumberSort(availableFirmwaresSchema.releaseDate), Cell: ReleaseDateCell                  },
                    { id: 'appliance',   header: t('SMP.SETTINGS.FIRMWARE.APPLIANCE'),    accessor: availableFirmwaresSchema.schemaClientProduct, width: 140,  sort: buildWeighedSort(availableFirmwaresSchema.schemaClientProduct, applianceWeights)                        },
                    { id: 'version',     header: t('SMP.SETTINGS.FIRMWARE.VERSION'),      accessor: availableFirmwaresSchema.clientVersion,       width: 200,  sort: buildStringSortCaseInsensitive(availableFirmwaresSchema.clientVersion)                              },
                    { id: 'description', header: t('SMP.DESCRIPTION'),                    accessor: availableFirmwaresSchema.firmDescription,     width: 400,  sort: buildStringSortCaseInsensitive(availableFirmwaresSchema.firmDescription)                          },
                    { id: 'type',        header: t('SMP.SETTINGS.FIRMWARE.TYPE'),         accessor: availableFirmwaresSchema.type,                width: 200,  sort: buildStringSortCaseInsensitive(availableFirmwaresSchema.type)                                 }
                ]}
                isRowSelectable={() => false}
                content={availableFirmwares}
                sortBasis={sortBasis}
                sortDirection={sortDirection}
                setSort={setSort}

            />
            {/* Popup windows */}
            <AddFirmwareToPortalModal
                isOpen={isAddFirmwareModalOpen}
                onRequestClose={closeAddFirmwareModal}
                onSuccess={() => {
                    closeAddFirmwareModal();
                    reloadSettingsFirmware();
                }}
            />
        </EditorLayout>
    )
}

export default PortalSettingsFirmware;